import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'siu-loader-configuration',
  templateUrl: './loader-configuration.component.html',
  styleUrls: [ './loader-configuration.component.scss' ]
})
export class LoaderConfigurationComponent implements OnInit {

  @Input() text: string = "Cargando configuración... Espere por favor...";

  constructor() { }

  ngOnInit() {
  }

}
